import { render, staticRenderFns } from "./PassthroughGet.vue?vue&type=template&id=1fbeecf6&"
import script from "./PassthroughGet.vue?vue&type=script&lang=js&"
export * from "./PassthroughGet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports